import { atom } from 'recoil';

export const navBar = atom({
  key: 'navBar',
  default: true,
});
